export default __webpack_public_path__ + "static/media/library_phone.f911687b.svg";